import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findInstructions = (headers, params) => {
    const dataParams = {
        ...params,
        filters: {
            ...params.filters,
            type: {
                value: "04",
                matchMode: "equals",
            },
        },
    };
    let query = buildQuery(dataParams, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/sysCategory${query}`, {
        headers,
    });
};

export const findInstructionById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/sysCategory/${id}`, {
        headers,
    });
};
